module.exports = __webpack_public_path__ + "img/ruiPatinhas.a6d3bac6.webp";